module.exports = __webpack_public_path__ + "static/33-acd4520ecd79471267b2c70e90411b87.png";